import { Component, input, signal } from '@angular/core';

@Component({
  selector: 'lgb-header-gradient',
  templateUrl: './header-gradient.html',
  styleUrl: './header-gradient.css',
  standalone: false
})
export class HeaderGradient {
  readonly height=input(100);
  readonly background=input(false);
}
